import { createSlice } from "@reduxjs/toolkit";
import {
  getUserFiles,
  getUserFolders,
  getAllClientDocuments,
  renameFolder,
  deleteFolder,
} from "../action/documentAction";
import { buildDocsTabUnreadPayload } from "../../utils/documentTabUnread";

const initialState = {
  userFiles: [],
  userFolders: [],
  allClientDocuments: [],
  /** Tab badge totals + by_folder from latest getUserDocs (unread_counts.received, etc.). */
  docsTabUnreadPayload: null,
  loading: false,
  error: null,
  message: null,
};

export const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserFiles.fulfilled, (state, action) => {
        const payload = action.payload;
        if (Array.isArray(payload)) {
          state.userFiles = payload;
          return;
        }
        state.userFiles = payload?.files ?? [];
        const unreadPayload = buildDocsTabUnreadPayload(
          payload?.unread_counts,
          payload?.by_folder,
        );
        if (unreadPayload) {
          state.docsTabUnreadPayload = unreadPayload;
        }
      })
      .addCase(getUserFolders.fulfilled, (state, action) => {
        state.userFolders = action.payload;
      })
      .addCase(getAllClientDocuments.fulfilled, (state, action) => {
        state.allClientDocuments = action.payload;
      })

      // Rename Folder
      .addCase(renameFolder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(renameFolder.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(renameFolder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Folder
      .addCase(deleteFolder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFolder.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(deleteFolder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default documentSlice.reducer;
